import { OverlayDimensions, PlacementGeometry } from "../types";

interface ComputeGeometryInput {
  container: HTMLElement | null;
  overlayDims: OverlayDimensions | null;
  sizePercent: number;
  positionXPercent: number;
  positionYPercent: number;
}

/**
 * Считает реальные размеры/позицию overlay'а в px поверх контейнера-подложки.
 * Должно совпадать с backend-логикой sharp: целевой размер — `sizePercent` от
 * меньшей стороны контейнера, scale рассчитан по большей стороне overlay'а
 * (keep aspect ratio).
 */
export const computeGeometry = ({
  container,
  overlayDims,
  sizePercent,
  positionXPercent,
  positionYPercent,
}: ComputeGeometryInput): PlacementGeometry | null => {
  if (!container || !overlayDims) return null;
  const rect = container.getBoundingClientRect();
  const minSidePx = Math.min(rect.width, rect.height);
  const targetPx = (minSidePx * sizePercent) / 100;
  const overlayMaxNat = Math.max(overlayDims.w, overlayDims.h, 1);
  const scale = targetPx / overlayMaxNat;
  return {
    containerRect: rect,
    minSidePx,
    displayW: overlayDims.w * scale,
    displayH: overlayDims.h * scale,
    leftPx: (rect.width * positionXPercent) / 100,
    topPx: (rect.height * positionYPercent) / 100,
  };
};
